import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Strips the lot-number suffix from a project name.
 *
 * During upload, each project's job_id (and display name) is built as:
 *   `${jobRaw}-${lotSuffix}`
 * where lotSuffix is the trimmed lot number from Excel column K (index 10),
 * or the literal string "unlotted" when no lot number is present.
 *
 * Examples:
 *   "R24-1111-3"        lot_number="3"    → "R24-1111"
 *   "R24-1111-unlotted" lot_number=null   → "R24-1111"
 *
 * @param name      - The raw project name / job_id as stored in the database.
 * @param lotNumber - The lot_number field from the project record (null for unlotted).
 * @returns The name with the lot suffix removed, or the original name if no match.
 */
export function stripLotSuffix(name: string, lotNumber?: string | null): string {
  // Determine the suffix that was appended during upload
  const suffix =
    lotNumber != null && String(lotNumber).trim() !== ''
      ? `-${String(lotNumber).trim()}`
      : `-unlotted`;

  if (name.endsWith(suffix)) {
    return name.slice(0, name.length - suffix.length).trim();
  }

  return name;
}

